import { setAdapter } from './registry.js';

// script 模式适配器加载器（<script> UMD 引入场景）
// 运行时动态创建 <script> 标签加载对应平台的 UMD adapter

// 默认 adapter 基础路径：自动取当前核心脚本所在目录下的 adapters/
const adapterBaseURL = getDefaultBaseURL();

function getDefaultBaseURL() {
  try {
    const scripts = document.getElementsByTagName('script');
    for (let i = scripts.length - 1; i >= 0; i--) {
      const src = scripts[i].src || '';
      if (src.indexOf('jx-bridge.core') > -1) {
        return src.substring(0, src.lastIndexOf('/')) + '/adapters';
      }
    }
  } catch (e) {}
  return './adapters';
}

// UMD adapter 挂载到 window 的全局变量名（rollup 构建时 name 配置为 JXAdapter_<platform>）
function getAdapterGlobalName(platform) {
  return 'JXAdapter_' + platform;
}

export function loadAdapter(platform) {
  const globalName = getAdapterGlobalName(platform);

  // 已加载过则直接取全局
  if (window[globalName]) {
    const adapter = window[globalName].default || window[globalName];
    setAdapter(adapter);
    return Promise.resolve(adapter);
  }

  return new Promise((resolve, reject) => {
    const url = adapterBaseURL + '/' + platform + '.js';
    const script = document.createElement('script');
    script.src = url;
    script.async = true;
    script.charset = 'utf-8';

    let settled = false;
    script.onload = () => {
      if (settled) return;
      const exported = window[globalName];
      if (exported) {
        const adapter = exported.default || exported;
        setAdapter(adapter);
        settled = true;
        resolve(adapter);
      } else {
        settled = true;
        reject(new Error('[JXBridge] adapter loaded but global not found: ' + globalName));
      }
    };
    script.onerror = () => {
      if (settled) return;
      settled = true;
      reject(new Error('[JXBridge] adapter load failed: ' + url));
    };

    document.head.appendChild(script);
  });
}
